module.exports = __webpack_public_path__ + "static/img/brees-2004-slide-3.809f5e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-slide-3.jpg
// module id = nn2i
// module chunks = 1